import _toConsumableArray from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { getAction, httpAction } from '@api/manage';
import { queryFileList, queryTemplateTowList, queryUserTreeList } from '@api/api';
import moment from 'moment';
import pick from 'lodash.pick'; // import newMap from '@/components/Map/newMap.vue'

import newMap from "../component/newMap.vue"; // import MapLineString from '@/components/Map/MapLineString'

/* table 巡检信息表头展示参数*/

var columns = [
/*title: '排序',
dataIndex: 'id',
scopedSlots: { customRender: 'id'*/
{
  title: '排序号',
  dataIndex: 'sort',
  align: 'center',
  width: '10%',

  /*scopedSlots: { customRender: 'recordId' }*/
  customRender: function customRender(text, record, index) {
    if (record.templateId && text != null) {
      return text;
    } else {
      return '-';
    }
  }
}, {
  title: '工艺名称及子项',
  dataIndex: 'name',
  align: 'left',
  width: '15%',

  /*scopedSlots: (text) => {
    return text
  }*/
  customRender: function customRender(text, record, index) {
    if (record.templateId && text != null) {
      return text;
    } else {
      return '-';
    }
  }
}, {
  title: '检查项',
  dataIndex: 'pname',
  align: 'center',
  width: '12%',
  customRender: function customRender(text, record, index) {
    /*if (text == null) {
      return '-'
    } else {
      return text
    }*/
    if (record.coordinateDifference == 0 && text == null) {
      return '-';
    } else {
      return record.name;
    }
  }
}, {
  title: '情况',

  /*dataIndex: 'val',*/
  dataIndex: 'defaultValue',
  align: 'center',
  width: '18%',
  customRender: function customRender(text) {
    if (text == null) {
      return '-';
    } else {
      return text;
    }
  }
}, {
  title: '情况说明',

  /*dataIndex: 'val',*/
  dataIndex: 'val',
  align: 'center',
  width: '18%',
  customRender: function customRender(text, record, index) {
    if (record.templateId && text != null) {
      return text;
    } else {
      return '-';
    }
  }
  /*customRender: (text) => {
    if (text == null) {
      return '-'
    } else if (text != null){
      return text
    }
  }*/

}, {
  title: '现场照片',
  dataIndex: 'pictures',
  align: 'center',
  width: '10%',
  scopedSlots: {
    customRender: 'pictures'
  }
}];
/* DataSource 定义表格数据源数组*/

var data1 = [];
export default {
  name: 'SitePipeInspectionRecordModal',
  mixins: [ModalFormMixin, JeecgListMixin],
  // 导入地图
  components: {
    newMap: newMap
  },
  data: function data() {
    return {
      pipePositionLists: [],
      selectType: 1,

      /* 站点名称*/
      pipeName: '',

      /* 站点ID*/
      pipeId: null,

      /* 模板列表*/
      templateOptions: [],
      // 巡检信息表头
      columns: columns,
      // 巡检信息表格数据
      data1: data1,
      queryParam: {},
      // 隐藏第二三面板
      showTab: false,
      // 抽屉默认面板
      paneChange: '1',
      // 图片相关 图片id
      imgId: '',
      // 是否显示图片
      showImgModal: false,
      // 模板预设坐标集
      templateCoordinateSet: [],
      // 人员信息
      userTree: [],
      modalName: '现场图片',
      title: '巡检记录表单',
      tableName: 'om_inspection_record',
      form_fields: ['category', 'pipeId', 'userId', 'templateId', 'weather', 'temperature', 'humidity', 'realCoordinate', 'remark', 'status'],
      form_fields_time: ['stime', 'etime'],
      validatorRules: {
        category: {
          rules: [{
            required: true,
            message: '请选择巡检类型!'
          }]
        },
        templateId: {
          rules: [{
            required: true,
            message: '请输入巡检模板!'
          }]
        },
        userId: {
          rules: [{
            required: true,
            message: '请选择巡检模板!'
          }]
        }
      },
      url: {
        tree: '/site/pipe/inspection/record/point/tree',
        imageUpload: window._CONFIG['domianURL'] + '/sys/common/file/upload',
        imgerver: window._CONFIG['domianURL'] + '/sys/common/file/view'
      }
    };
  },
  props: ['pagePath'],
  created: function created() {
    // 加载巡检模板列表
    this.queryTemplateList();
    /* 渲染地图数据pointCoordinateSet*/

    this.loadInspectionTree();
  },
  methods: {
    //加载人员信息
    loadTreeList: function loadTreeList() {
      var _this = this;

      var that = this;
      that.userTree = []; // 用户

      queryUserTreeList().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.userTree.push(temp);
          }

          _this.loading = false;
        }
      });
    },

    /* 通过模板id查询模板预设坐标集templateId*/
    queryTemplateCoordinateSetList: function queryTemplateCoordinateSetList(templateId) {
      var that = this;
      queryTemplateTowList({
        id: templateId
      }).then(function (Template) {
        if (Template.success) {
          that.templateCoordinateSet = Template.result.records;
        }
      });
    },
    coordinateOk: function coordinateOk(value) {
      var that = this;

      if (value != null) {
        var a = '';
        value.forEach(function (element, index) {
          var b = '';
          element.forEach(function (item, i) {
            b += i == element.length - 1 ? item.join(',') : item.join(',') + '-';
          });
          a += index == value.length - 1 ? b : b + ':';
        }); // console.log(a, '抽屉2')

        this.form.setFieldsValue({
          coordinate: value ? a : null
        });
        this.model.coordinate = value ? a : null;
      }
    },
    coordinateChange: function coordinateChange() {
      // console.log(this.model.coordinate)
      this.$refs.mapLine.show(this.model.coordinate);
    },
    // 查看文件
    openFile: function openFile(text) {
      var _this2 = this;

      if (!text) {
        this.$message.warning('未知的文件');
        return;
      }

      this.imgId = '';
      this.$nextTick(function () {
        _this2.imgId = _this2.getImgView(text);
        _this2.showImgModal = true;
      });
    },
    // 图片预览
    getImgView: function getImgView(text) {
      return this.url.imgerver + '/' + text;
    },
    // 现场图片关闭
    setModal1Visible: function setModal1Visible() {
      this.showImgModal = false;
    },
    add: function add() {
      this.edit({});
    },
    // 编辑
    edit: function edit(record) {
      var _this3 = this;

      record.manualSign = decodeURIComponent(record.manualSign);
      this.loadTreeList();
      this.queryTemplateList(); // 加载巡检模板列表

      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true; //

      if (!record.id) {
        this.model.pipeId = this.pipeId;
        this.model.pipeName = this.pipeName;
      }
      /* this.data1 = []
       this.formItem.resetFields()*/
      //通过模板id查询模板预设坐标集templateId


      if (record.templateId) {
        this.queryTemplateCoordinateSetList(record.templateId);
      }
      /*if (this.model.id != null) {
        // 编辑
        this.getRelatedTypeList(this.model.category, this.model.relatedType)
        //this.siteChange(this.model.relatedType)
      } else {
        setTimeout(() => {
          // 添加
          this.form.setFieldsValue({ status: '1' })
          this.form.setFieldsValue({ isGps: '1' })
        }, 300)
      }*/


      this.$nextTick(function () {
        if (!record.id) {
          _this3.form.setFieldsValue({
            category: '1'
          });

          _this3.form.setFieldsValue({
            status: '1'
          });
        } else {
          _this3.model.category = _this3.model ? _this3.model.category ? _this3.model.category.toString() : null : null;
          _this3.model.status = _this3.model ? _this3.model.status ? _this3.model.status.toString() : null : null;
        }

        _this3.form.setFieldsValue(pick(_this3.model, _this3.form_fields)); // 时间格式化


        _this3.form.setFieldsValue({
          stime: _this3.model.stime ? moment(_this3.model.stime) : null
        });

        _this3.form.setFieldsValue({
          etime: _this3.model.etime ? moment(_this3.model.etime) : null
        });
      });
    },
    handleOk: function handleOk() {
      var _this4 = this;

      var that = this; // 触发表单验证

      this.form.validateFields(function (err, values) {
        if (!err) {
          that.confirmLoading = true;
          var httpurl = '';
          var method = '';

          if (!_this4.model.id) {
            httpurl = _this4.url.add ? _this4.url.add : _this4.pagePath;
            method = 'post';
          } else {
            httpurl = _this4.url.edit ? _this4.url.edit : _this4.pagePath;
            method = 'put';
          }

          var formData = Object.assign(that.model, values);
          formData.pipeId = that.pipeId;
          formData.stime = formData.stime ? moment(formData.stime) : null;
          formData.stime = formData.stime ? formData.stime.format('YYYY-MM-DD HH:mm:ss') : null;
          formData.etime = formData.etime ? moment(formData.etime) : null;
          formData.etime = formData.etime ? formData.etime.format('YYYY-MM-DD HH:mm:ss') : null;
          /* formData.planSdate = that.planDateData.planSdateBack
           formData.planEdate = that.planDateData.planEdateBack*/

          httpAction(httpurl, formData, method).then(function (res) {
            if (res.success) {
              that.$notification.success({
                message: res.message
              });
              that.$emit('ok');
              that.close();
            } else {
              that.$notification.warning({
                message: res.message
              });
            }
          }).finally(function () {
            that.confirmLoading = false;
          });
        }
      });
    },
    close: function close() {
      this.templateOptions = []; // 巡检模板制空

      this.hiddenButton = true; // 设为true 每次关闭重置  不影响确定按钮的&&

      this.$emit('close');
      this.visible = false;
      this.paneChange = '1'; // 抽屉框永远显示第一面板 可避免点击更多编辑后选择第二个面板，再关闭后点击新增时显示不正常
    },
    // 切换面板时重载
    handleTabChange: function handleTabChange(key) {
      var _this5 = this;

      if (key == '1') {
        this.hiddenButton = true; // 展示本页面确定取消
      }

      this.paneChange = key;

      if (key == '2') {
        if (this.model.status != null) {
          //this.model.status ==2 todo
          this.loadInspectionTree();
        }

        this.hiddenButton = false; // 隐藏本页面确定取消
      }

      if (key == '3') {
        var that = this;
        var pointCoordinateSetItem = [];
        that.hiddenButton = false; // 隐藏本页面确定取消

        getAction(this.url.tree + '/' + that.model.id, {
          type: 1
        }).then(function (res) {
          if (res.success && res.result) {
            /* 取出点位坐标缓存在pointCoordinateSetItem坐标集中*/
            res.result.forEach(function (tree) {
              tree.children.forEach(function (data) {
                pointCoordinateSetItem.push(data.coordinate);
              });
            });
            var polyLine = [];
            res.result.forEach(function (item) {
              var obj = {
                childArr: []
              };

              if (item.children) {
                item.children.forEach(function (item1) {
                  obj.childArr.push({
                    coordinate: item1.realCoordinate,
                    imageId: item1.imageId,
                    name: item1.name
                  });
                });
              }

              polyLine.push(obj);
            });
            console.log('polyLine', polyLine); // 只展示预设点位坐标 图标

            if (that.model.realCoordinate) {
              that.center = that.model.realCoordinate.split('-')[0];
              that.showReal(that.model.realCoordinate, polyLine);
            } else if (that.templateCoordinateSet.length != 0) {
              // 解开可看到每分钟12次获取的真实数据

              /*that.show(this.model.routes, pointCoordinateSetItem)*/
              console.log('polyLine', polyLine);
              console.log('that.templateCoordinateSet[2].coordinate, pointCoordinateSetItem', that.templateCoordinateSet[2].coordinate, pointCoordinateSetItem);
              that.show(polyLine, polyLine);
            } else {
              that.show('', polyLine);
            }
          } else {
            _this5.pipePositionLists = [];
          }
        });
      }
    },
    showReal: function showReal(lines, markerList) {
      var _this6 = this;

      var line = [];

      if (lines) {
        var pointList = lines.split(':');
        line = pointList.map(function (v) {
          return v.split('-').map(function (item) {
            return item.split(',');
          });
        });
      }

      this.mapPointList = _toConsumableArray(line);
      console.log('mapPointList', this.mapPointList);
      this.selectType = 1;
      this.visible = true;
      console.log('this.line', this.line);
      this.showTab = false;
      this.pipePositionLists = this.mapPointList;
      this.$nextTick(function () {
        _this6.showTab = true;

        _this6.$nextTick(function () {
          _this6.$refs.newMap.pipePositionList = _this6.mapPointList;
          _this6.$refs.newMap.areaName = '青岛市';
          _this6.$refs.newMap.pipeMarkerPositionList = markerList;

          _this6.$refs.newMap.initMap();

          _this6.$refs.newMap.drawBounds(1);

          _this6.$forceUpdate();
        });
      });
    },
    // 加载巡检记录对应的巡检点point和巡检内容items
    loadInspectionTree: function loadInspectionTree() {
      var that = this;
      /* 记录的id*/

      var params = that.model.id;
      getAction(this.url.tree + '/' + that.model.id, {
        type: 1
      }).then(function (res) {
        if (res.success) {
          /*that.getChild(res)*/

          /* 取出点位坐标缓存在pointCoordinateSet坐标集中*/

          /*res.result.forEach((tree) => {
            that.pointCoordinateSet.push(tree.coordinate)
          })*/
          res.result.forEach(function (item, index) {
            item.children.forEach(function (item1, index1) {
              that.toTreePicture(item1);

              if (item1.children == null && item1.items.length > 0) {
                item1.children = item1.items;
                item1.children.forEach(function (i) {
                  if (item1.name != null) i.pname = item1.name;
                });
              }
            });
          });
          /* 数据复杂还没渲染完，dom元素已经加载完成 所以做延时处理*/

          setTimeout(function () {
            that.data1 = res.result;
          }, 800);
        }
      });
    },

    /* 递归获取图片*/
    toTreePicture: function toTreePicture(item) {
      var _this7 = this;

      if (item.imageId) {
        queryFileList('site_pipe_inspection_record_point', item.imageId).then(function (vo) {
          if (vo.success) {
            item.pictures = vo.result;
          }
        });

        if (item.children) {
          item.children.forEach(function (item, index) {
            _this7.toTreePicture(item);
          });
        }
      } else {
        return;
      }
    },

    /* 加载 模板列表*/
    queryTemplateList: function queryTemplateList() {
      var that = this;
      that.templateOptions = [];
      getAction('/om/inspection/template', {
        pageNo: 1,
        pageSize: 10000
      }).then(function (res) {
        if (res.success) {
          // 模板类型
          that.templateOptions = res.result.records;
          /*this.idItem = res.result
          this.form.setFieldsValue({ code: 'TPL' + moment().format('YYMMDD') + '00' + this.idItem })*/
        } else {
          console.log(res.message);
        }
      });
    },

    /*地图开始*/
    // 地图画线功能点击确定后的回调
    labelPosition: function labelPosition(value) {
      this.mapPointList = value;
    },
    show: function show(parmCenter) {
      var _this8 = this;

      this.line = [];

      if (parmCenter) {
        this.line = parmCenter.map(function (v) {
          return v.childArr.map(function (item) {
            return item.coordinate.split(',');
          });
        });
      }

      console.log('line', this.line); // console.log(this.line, '回显')

      this.mapPointList = _toConsumableArray(this.line);
      this.selectType = 1;
      this.visible = true;
      console.log('this.line', this.line);
      console.log('this.mapPointList', parmCenter);
      this.pipePositionLists = this.line;
      this.$nextTick(function () {
        _this8.showTab = true;

        _this8.$nextTick(function () {
          _this8.$refs.newMap.pipePositionList = _this8.line;
          _this8.$refs.newMap.areaName = '青岛市';
          _this8.$refs.newMap.pipeMarkerPositionList = parmCenter;

          _this8.$refs.newMap.initMap();

          _this8.$refs.newMap.drawBounds(1);

          _this8.$forceUpdate();
        });
      });
    }
    /*地图结束*/

  }
};